'use client';

import { createContext, type PropsWithChildren, useContext } from 'react';

import type { ModalTransitionState } from '@/hooks/useModalTransitions';

export interface DropdownContextType extends ModalTransitionState {
    dropdownId: string;
    popperReference: HTMLDivElement | null;
    triggerReference: HTMLElement | null;
    setPopperReference: (element: HTMLDivElement | null) => void;
    setTriggerReference: (element: HTMLElement | null) => void;
    triggerId: string;
}

const DropdownContext = createContext<DropdownContextType | undefined>(undefined);

export function DropdownContextProvider({
    children,
    ...value
}: PropsWithChildren<DropdownContextType>) {
    return <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>;
}

export function useDropdownContext(): DropdownContextType {
    const context = useContext(DropdownContext);

    if (!context) {
        throw new Error('`useDropdownContext` can only be used inside `DropdownContextProvider`');
    }

    return context;
}
